
import { Component, OnInit, ViewChild, Inject } from '@angular/core';
import { DataSource } from '@angular/cdk/table';
import { MatPaginator } from '@angular/material';

import { BehaviorSubject } from 'rxjs/BehaviorSubject';
import { Observable } from 'rxjs/Observable';
import { RestApiService } from '../shared/restApiServices/restapi.service';
import 'rxjs/add/operator/startWith';
import 'rxjs/add/observable/merge';
import 'rxjs/add/operator/map';
import { NewSurveyerDialogComponent } from '../newSurveyerDialog/new-surveyer-dialog.component'
import { ManageSurveyerDialogComponent } from '../manage-surveyer-dialog/manage-surveyer-dialog.component'
import { DeleteAlertDialogComponent } from '../delete-alert-dialog/delete-alert-dialog.component'
import { LoaderService } from '../shared/services/loader.service'
import { NoSurveyerService } from '../shared/services/no-surveyer.service'
import { isUndefined } from "util";
import { TabsDataService } from "../shared/services/tabs-data.service"
import { isNullOrUndefined } from "util";
import { MatDialog, MatDialogRef, MAT_DIALOG_DATA } from '@angular/material';
import { Route } from '@angular/router';
import { Router } from '@angular/router';
import {ToastyService, ToastyConfig, ToastOptions, ToastData} from 'ng2-toasty';
import { Subject, Subscription } from 'rxjs';
import { debounceTime, delay, distinctUntilChanged, map, mergeMap } from 'rxjs/operators';
import { of } from 'rxjs/observable/of';
import { superAdminService } from 'app/shared/services/superAdminService';
declare var amplitude:any;


@Component({
  selector: 'app-surveyers',
  templateUrl: './surveyers.component.html',
  styleUrls: ['./surveyers.component.css']
})

export class SurveyersComponent implements OnInit {
  displayedColumns = ['sno','Name', 'mobile', 'Team', 'Status', 'Actions'];
  exampleDatabase: ExampleDatabase;
  dataSource: ExampleDataSource | null;
  newSurveyerDialogRef: any;
  manageSurveyerDialog: any;
  deleteAlertDialogRef: any;
  // showDelete:boolean;
  checkedRows: string[];
  showLoader: boolean = true;
  noSurveyerCreated: boolean = true;
  user: string;
  userHeader: string;
  companyName:string;

  switchOrgList:{orgName:string,superAdminID:string}[]=[];

  @ViewChild(MatPaginator) paginator: MatPaginator;
  searchText = new BehaviorSubject<{
    searchBy:'name'|'phone'|'teamname'|'status',orderby:'teamnames'|'status',orderSeq:'asc'|'asc',
    search:string}>({searchBy:null,orderby:null,orderSeq:null,search:null});
  surveyorlist:surveyerDetail2[] =[];

  searchBy:'name'|'phone';
  onSearch = new Subject<string>();
  subscription: Subscription;
  teamList =[];
  selectedTeam;
  selectedStatus;
  surveyorName;
  mobileNo;
  superAdmin = false;

  constructor(public restApiService: RestApiService, public dialog: MatDialog, 
    public loaderService: LoaderService, public noSurveyerService: NoSurveyerService,
     public tabsDataService:TabsDataService,private toastyService:ToastyService, 
     private toastyConfig: ToastyConfig, private superAdminService:superAdminService,
     private router:Router) {

    this.loaderService.setLoader(true);
    this.loaderService.getLoader().subscribe(message => 
      { if (message != null) 
        { this.showLoader = message } 
      });
    this.noSurveyerService.setNoSurveyer(false);
    this.noSurveyerService.getNoSurveyer().subscribe(message => { 
      if (message != null) 
      { this.noSurveyerCreated = message } 
    });

    this.searchText.subscribe(response=>{
      if(response){
        this.getSurveyorList(response.searchBy,response.orderby,response.orderSeq,response.search);
      }
    })
    this.subscription = this.onSearch.pipe(
      map(value => value),
      debounceTime(1000),
      distinctUntilChanged(),
      mergeMap(search => of(search).pipe(
        delay(500),
      )),
    ).subscribe(data=>{
      if(data != ''){
        let searchBy;
        if(this.searchBy == 'name'){
          searchBy = 'name';
        }
        if(this.searchBy == 'phone'){
          searchBy = 'phone'
        }
        const searchText = data;
        this.searchText.next({searchBy:searchBy,orderby:null,orderSeq:null,search:searchText});
      }
      else{
        this.searchText.next({searchBy:null,orderby:null,orderSeq:null,search:null});
      }
    });
    // checking if it is manager or not..
    if (this.superAdminService.hasData()) {
      this.superAdmin = this.superAdminService.getData();
    } else {
      this.restApiService.checkIfSuperAdmin().subscribe(
        result => {
          if (result.checkIfSuperAdmin == true) {
            this.superAdmin = true;
            this.superAdminService.setData(this.superAdmin);
          }
          else {
            this.superAdmin = false;
            this.superAdminService.setData(this.superAdmin);
          }
        });
    }

    this.getTeamList();
  }

  ngOnInit() {
    // this.exampleDatabase = new ExampleDatabase(this.restApiService, this.loaderService, this.noSurveyerService, this.tabsDataService);
    // this.dataSource = new ExampleDataSource(this.exampleDatabase, this.paginator);
    this.user = localStorage.getItem("username");
    this.userHeader = localStorage.getItem("user_name_header");
    this.companyName = localStorage.getItem('companyName');
    this.switchOrgList = this.restApiService.getSwitchOrgList();
  }

  onSelectOrg(org:{orgName:string,superAdminID:string}){
    if(org && org.superAdminID && org.superAdminID != undefined && org.orgName && org.orgName){
      localStorage.setItem('superAdminID',org.superAdminID);
      localStorage.setItem('companyName',org.orgName);
      this.companyName = org.orgName;
      // this.restApiService.orgName.next(this.companyName);
      // this.exampleDatabase = new ExampleDatabase(this.restApiService, this.loaderService, this.noSurveyerService, this.tabsDataService);
      // this.dataSource = new ExampleDataSource(this.exampleDatabase, this.paginator);
      this.getSurveyorList(null,null,null,null);
    }
  }
  openSettings(){
    this.router.navigateByUrl('/userProfile');
  }

  getTeamList(){
    this.restApiService.getGroupListWithDetailsForAdminService(null).subscribe(
      result => {
        this.teamList = result.groups;
      });
  }

  onSelectTeam(teamName){
    // remove filter on all select
    if(teamName == '---all---'){
      this.selectedTeam= null;
      this.searchText.next({searchBy:null,search:null,orderby:null,orderSeq:null});
    }
    else{
      this.selectedTeam = teamName;
      this.searchText.next({searchBy:'teamname',search:this.selectedTeam,orderby:null,orderSeq:null});
      this.surveyorName='';
      this.mobileNo='';
    }
  }
  onSelectStatus(status){
    if(!status){
      this.searchText.next({searchBy:null,search:null,orderby:null,orderSeq:null});
      this.selectedStatus = null;
      this.selectedTeam = null;
      this.surveyorName='';
      this.mobileNo='';
      return;
    }
    this.selectedStatus = status;
    this.searchText.next({searchBy:'status',search:this.selectedStatus,orderby:null,orderSeq:null});
    this.selectedTeam = null;
    this.surveyorName='';
    this.mobileNo='';
  }

  getSurveyorList(searchBy,orderby,orderSeq,search){
    this.showLoader = true;
    this.restApiService.getSurveyerList(search,searchBy,orderSeq,orderby).subscribe(response=>{
      if(response && response.success && response.Users){
        this.surveyorlist = [];
        response.Users.forEach(data=>{
          let status;
          let action;
          if (data.status == 1) {
            status = 'Added';
            action = 'View Details';
          }
          else if (data.status == 2) {
            status = 'Invitation sent';
            action = 'Resend Invite';
          }
          else if (data.status == 3) {
            status = 'Invitation sent';
            action = 'Resend Invite';
          }
          let teams = 'Assign team';
          if(data.teamnames && data.teamnames.length !=0 && data.teamnames[0] != null){
            teams = "";
            if(data.teamnames.length == 1){
              teams = data.teamnames[0];
            }
            if(data.teamnames.length>1){
              const remainLength = data.teamnames.length -1;
              teams = data.teamnames[0] + " and " + remainLength + "more"
            }
          }
          this.surveyorlist.push({Name:data.Name!=null?data.Name:'-',mobile:data.userName,Status:status,
          Team:teams, Actions:action,userName:data.userName,manager:data.manager,createdAt:data.createdAt,
          uID:data.uID,teamids:data.teamids});
        });
      }
      if(this.surveyorlist.length !=0){
        this.noSurveyerCreated = false;
      }
      this.showLoader = false;
    },error=>{
      this.showLoader = false;
    })
  }
  


  deleteSurveyer(row) {
    if(!(this.user==row.manager|| row.manager =="Self" || row.action == "View Details")){
      return;
    }
    this.deleteAlertDialogRef = this.dialog.open(DeleteAlertDialogComponent, {
      data: row,
      height: '285px',
      width: '400px',
    });

    this.deleteAlertDialogRef.afterClosed().subscribe(result => {
      if (result.success && result != undefined) {
        this.loaderService.setLoader(true);
        this.tabsDataService.setSurveyorDataTobeUpdated(true);
        this.exampleDatabase = new ExampleDatabase(this.restApiService, this.loaderService, this.noSurveyerService, this.tabsDataService);
        this.dataSource = new ExampleDataSource(this.exampleDatabase, this.paginator);
        this.getSurveyorList(null,null,null,null);
        //delete the surveyer
      }
    });
  }

  openCreateSurveyerDialog() {
    amplitude.getInstance().logEvent('AddSurveyorclicked');
    this.newSurveyerDialogRef = this.dialog.open(NewSurveyerDialogComponent, {
      height: '450px',
      width: '700px',
    });

    this.newSurveyerDialogRef.afterClosed().subscribe(result => {
      // if(result)
      // {
      //   this.noSurveyerCreated = false;
      // }
      this.getSurveyorList(null,null,null,null);;
      this.loaderService.setLoader(true);
      this.tabsDataService.setSurveyorDataTobeUpdated(true);
      this.exampleDatabase = new ExampleDatabase(this.restApiService, this.loaderService, this.noSurveyerService, this.tabsDataService);
      this.dataSource = new ExampleDataSource(this.exampleDatabase, this.paginator);
    });
  }

  addToTeam(row) {
    let dialogRef = this.dialog.open(AddTeamDialogComponent, {
      width: '68%',
      height: '600px',
      data: row
    });
    dialogRef.afterClosed().subscribe(result => {
      // this.noSurveyerCreated = false;
      // this.loaderService.setLoader(true);
      // this.tabsDataService.setSurveyorDataTobeUpdated(true);
      // this.exampleDatabase = new ExampleDatabase(this.restApiService, this.loaderService, this.noSurveyerService, this.tabsDataService);
      // this.dataSource = new ExampleDataSource(this.exampleDatabase, this.paginator);
      this.getSurveyorList(null,null,null,null);
    });
  }

  showSurveyors(row){
    let surveyors = [];
    let surveyorNames = [];
    let surveyorMobiles = [];
    let currentIndex = 0;
    for (let index = 0; index < this.surveyorlist.length; index++) {
      if(this.surveyorlist[index].mobile == row.mobile){
        currentIndex = index;
        break;
      }
    }
    this.surveyorlist.forEach(data=>{
      surveyors.push(data.uID);
      surveyorNames.push(data.Name);
      surveyorMobiles.push(data.mobile);
    })
    // row.surveyors = surveyors;
    // row.surveyorNames = surveyorNames;
    // row.surveyorMobiles = surveyorMobiles;
    row.surveyorList  = this.surveyorlist;
    row.currentIndex = currentIndex;
    let dialogRef = this.dialog.open(SurveyorDialogComponent, {
      width: '68%',
      height: '600px',
      data: row
    });
    dialogRef.afterClosed().subscribe(result => {
      if(result && result.assignTeam && result.row){
        this.addToTeam(result.row);
      }
    });
  }

  applyFilter(filterValue: string) {
    // this.dataSource.filter = filterValue.trim().toLowerCase();
  }
  onManageSurveyer(row) {
    if (row.Actions == "View Details") {
      this.manageSurveyerDialog = this.dialog.open(ManageSurveyerDialogComponent, {
        width: '400px',
        data: row
      });
    }
    else {
      this.restApiService.inviteSurveyerService(row.userName).subscribe(
        result => {
          if (result.status == 'invited') {
            this.restApiService.updateinvitesent(row.userName).subscribe(result => {
              this.tabsDataService.setSurveyorDataTobeUpdated(true);
              this.exampleDatabase = new ExampleDatabase(this.restApiService, this.loaderService, this.noSurveyerService, this.tabsDataService);
              this.dataSource = new ExampleDataSource(this.exampleDatabase, this.paginator);
            });
            var toastOptions:ToastOptions = {
              title: "Invitation Sent",
              msg: "Invitation was successfully sent to the surveyor",
              showClose: true,
              timeout: 3000,
              theme: 'bootstrap'
            };
            this.toastyService.success(toastOptions);
          }
        });
    }
  }
}

export interface surveyerDetail {
  Name: string,
  mobile: string,
  Status: string,
  Team: string,
  Actions: string,
  userName : string,
  manager : string
}
export interface surveyerDetail2 {
  Name: string,
  mobile: string,
  Status: string,
  Team: string,
  Actions: string,
  userName : string,
  manager : string,
  createdAt: string,
  uID:string,
  teamids:string[]
}


export class ExampleDatabase {
  /** Stream that emits whenever the data has been modified. */
  dataChange: BehaviorSubject<surveyerDetail[]> = new BehaviorSubject<surveyerDetail[]>([]);
  get data(): surveyerDetail[] { return this.dataChange.value; }
  restApiService: RestApiService;
  loaderService: LoaderService;
  noSurveyerService: NoSurveyerService;
  tabsDataService: TabsDataService;

  constructor(restApiService: RestApiService, loaderService: LoaderService, noSurveyerService: NoSurveyerService, tabsDataService: TabsDataService) {
    // Fill up the database with 100 users.
    this.restApiService = restApiService;
    this.loaderService = loaderService;
    this.noSurveyerService = noSurveyerService;
    this.tabsDataService = tabsDataService;

      this.restApiService.getSurveyerList(null,null,null,null).subscribe(
        result => {
          if (result == null || isUndefined(result.Users) || result.Users.length == 0) {
            this.loaderService.setLoader(false);
            this.noSurveyerService.setNoSurveyer(true);
          }
          else {
            let users = result.Users;
            for (let i = 0; i < users.length; i++) {
              this.addUser(users[i]);
            }
            if(users.length > 0){
              this.noSurveyerService.setNoSurveyer(false);
            }
            this.tabsDataService.setSurveyorTabData(users);
            this.tabsDataService.setSurveyorDataTobeUpdated(false);
            this.loaderService.setLoader(false);
          }
        });
  }

  /** Adds a new user to the database. */
  addUser(user) {
    const copiedData = this.data.slice();
    copiedData.push(this.createNewUser(user));
    this.dataChange.next(copiedData);
  }

  /** Builds and returns a new User. */
  private createNewUser(user) {
    if (user.status == 1) {
      user.status = 'Added';
      user.action = 'View Details';
    }
    else if (user.status == 2) {
      user.status = 'Send Invite';
      user.action = 'Send Invite';
    }
    else if (user.status == 3) {
      user.status = 'Invitation sent';
      user.action = 'Resend Invite';
    }
    return user;
  }
}

/**
 * Data source to provide what data should be rendered in the table. Note that the data source
 * can retrieve its data in any way. In this case, the data source is provided a reference
 * to a common data base, ExampleDatabase. It is not the data source's responsibility to manage
 * the underlying data. Instead, it only needs to take the data and send the table exactly what
 * should be rendered.
 */
export class ExampleDataSource extends DataSource<any> {
  _filterChange = new BehaviorSubject('');
  get filter(): string { return this._filterChange.value; }
  set filter(filter: string) { this._filterChange.next(filter); }

  _filterChange2 = new BehaviorSubject('');
  get filter2(): string { return this._filterChange2.value; }
  set filter2(filter2: string) { this._filterChange2.next(filter2); }

  constructor(private _exampleDatabase: ExampleDatabase, private _paginator: MatPaginator) {
    super();
  }

  /** Connect function called by the table to retrieve one stream containing the data to render. */
  connect(): Observable<surveyerDetail[]> {
    const displayDataChanges = [
      this._exampleDatabase.dataChange,
      this._paginator.page,
      this._filterChange,
    ];
    
    return Observable.merge(...displayDataChanges).map(() => {
      const data = this._exampleDatabase.data.slice();

      // Grab the page's slice of data.
      const startIndex = this._paginator.pageIndex * this._paginator.pageSize;
      const renderedData = data.splice(startIndex, this._paginator.pageSize);
      return renderedData.filter((item: surveyerDetail) => {
        let searchStr = (item.Name + item.userName + item.manager).toLowerCase();
        return searchStr.indexOf(this.filter.toLowerCase()) != -1;
      });
    });
  }

  disconnect() { }
}
@Component({
  selector: 'add-to-team-dialog',
  templateUrl: 'add-to-team-dialog.html',
  styleUrls: ['add-to-team.css']
})
export class AddTeamDialogComponent {
  teamList = [];
  displayedColumns = ['teamName','surveyors','createdAt', 'status'];
  user: string;
  noTeamCreated: boolean;
  showLoader: boolean;
  constructor(public restApiService: RestApiService, private router: Router,
    public dialogRef: MatDialogRef<AddTeamDialogComponent>, @Inject(MAT_DIALOG_DATA) public data: any) {
    this.user = localStorage.getItem("username");
    this.showLoader=true;
    this.restApiService.getGroupListWithDetailsForAdminService(null).subscribe(
      result => {
        this.teamList = [];
        for (let i in result.groups) {
          if (result.groups[i].manager == this.user || result.groups[i].manager == 'Self') {
            if (this.data.teamids.includes(result.groups[i].id)) {
              result.groups[i].status = 'Added';
              this.teamList.push(result.groups[i])
            }
            else {
              result.groups[i].status = 'Add';
              this.teamList.push(result.groups[i])
            }
          }
        }
        if (this.teamList.length == 0) {
          this.noTeamCreated = true;
        }
        else {
          this.noTeamCreated = false;
        }
        this.showLoader = false;
      });
  }

  assignTeam(data) {
    this.restApiService.setTeamForSurveyor(this.data.userName, this.teamList[data].teamName).subscribe(
      result => {
        if(result.success== true)
        {
          this.teamList[data].status= 'Added';
        }
      });
  }

  createTeam() {
    this.dialogRef.close();
    this.router.navigateByUrl('/groups');
  }
  unassignTeam(data) {
    this.restApiService.removeTeamForSurveyor(this.data.uID, this.teamList[data].id).subscribe(
      result => {
        if(result.success== true)
        {
          this.teamList[data].status= 'Add';
        }
      });
  }

  onClose() {
    this.dialogRef.close();
  }
  getNumOfSurveyors(element){
    let uIds = element.uIDs;
    let count = 0;
    if(uIds.length>0){
      uIds.forEach(data=>{
        if(data != null){
          count = count +1;
        }
      })
    }
    return count;
  }
}



@Component({
  selector: 'surveyor-dialog',
  templateUrl: 'surveyor-dialog.html',
  styleUrls: ['surveyor-dialog.css']
})
export class SurveyorDialogComponent {

  surveyorList: {teamName:string,addedOn:string,createdBy:string}[]=[];
  displayedColumns= ['teamName','addedOn','createdBy'];
  surveyorList_ = [];
  currentIndex = -1;
  uid;
  surveyName;
  constructor(public restApiService: RestApiService,
    public dialogRef: MatDialogRef<SurveyorDialogComponent>, @Inject(MAT_DIALOG_DATA) public data: any) {
      if(data){
        this.uid = data.uID;
        this.surveyorList_ = data.surveyorList;
        this.currentIndex = data.currentIndex;
        this.surveyName = data.Name;
        this.getSurveyorTeams();
      }
  }

  getSurveyorTeams(){
    this.restApiService.getSurveyorTeams(this.uid).subscribe(response=>{
      if(response && response.success && response.data){
        const data= response.data;
        this.surveyorList = [];
        data.forEach(data=>{
          const date = data.user_added_timestamp[data.position - 1];
          let addedOn;
          if(date == -1){
            addedOn = '-'
          }
          else{
            addedOn = new Date(date*1000).toLocaleDateString("en-US");
          }
          this.surveyorList.push({teamName:data.team_name, addedOn:addedOn,createdBy:data.created_by})
        })
      }
    })
  }

  onClose(){
    this.dialogRef.close();
  }

  showPrevious(){
    if(this.currentIndex !=0){
      this.currentIndex = this.currentIndex -1;
      this.uid = this.surveyorList_[this.currentIndex].uID;
      this.surveyName = this.surveyorList_[this.currentIndex].Name!='-'?
                          this.surveyorList_[this.currentIndex].Name:
                          this.surveyorList_[this.currentIndex].mobile;
      this.surveyorList = [];
      if(this.uid && this.uid != ''){
        this.getSurveyorTeams();
      }
    }
  }

  showNext(){
    if(this.currentIndex != this.surveyorList_.length-1){
      this.currentIndex = this.currentIndex +1;
      this.uid = this.surveyorList_[this.currentIndex].uID;
      this.surveyName = this.surveyorList_[this.currentIndex].Name!='-'?
                          this.surveyorList_[this.currentIndex].Name:
                          this.surveyorList_[this.currentIndex].mobile;
      this.surveyorList = [];
      if(this.uid && this.uid != ''){
        this.getSurveyorTeams();
      }
    }
  }

  assignTeam(){
    let row = this.surveyorList_[this.currentIndex];
    this.dialogRef.close({assignTeam: true,row:row});
  }
}



// WEBPACK FOOTER //
// ./src/app/surveyers/surveyers.component.ts